var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSellerSignUpBottomBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "none",
    viewBox: "0 0 1440 191",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1278.5 118.685C1354.32 92.974 1403.11 6.588 1440 0v191H0c24.098-1.924 59.238-17.446 101.5-41.953 62-35.954 79.639-44.675 118-65.139C257.861 63.444 380.496 0 491 0 608 0 819.857 43.34 950 83.908c170 52.993 237.39 65.676 328.5 34.777Z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M145.789 69.846C92.651 61.281 26.127 55.83 0 51v140h1020c-17.07-1.41-44.939-4.872-76.291-16.538-42.182-15.697-92.744-38.209-121.67-50.605-76.07-32.6-114.971-53.967-176.151-63.333-99.539-15.238-175.457 30.185-271.217 32.857-133.248 3.718-133.092-8.095-228.882-23.535Z",
    fill: "url(#b)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0,
    y1: 0,
    x2: 622.876,
    y2: 815.283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE4E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4E5",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 975.822,
    y1: 191,
    x2: 343.842,
    y2: 592.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD2D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4E5",
    stopOpacity: 0.33
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSellerSignUpBottomBackground);
export default __webpack_public_path__ + "static/media/sellerSignUpBottomBackground.f1609d9aadc7f86f3c9dc0d178a73597.svg";
export { ForwardRef as ReactComponent };